import { IPagination } from "../../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../../shared/interfaces/shared/IBase";
import { requests } from "../../../utils/api/api.service";
import {
  WEB_INCIDENTS_URL,
  WEB_INCIDENT_TYPES_URL,
  WEB_INCIDENT_STATUS_TYPES_URL,
  WEB_INCIDENT_ACTIVITIES_URL,
} from "../../../utils/api/endpoints";
import {
  IIncident,
  IIncidentCreate,
  IIncidentDetails,
} from "../../../shared/interfaces/incident/IIncident";

export const WebIncidentService = {
  getAll: (params: IPagination): Promise<IBaseModel<IIncident[]>> =>
    requests.get(WEB_INCIDENTS_URL, params),
  getSingle: (id: number): Promise<{ data: IIncident }> =>
    requests.get(`${WEB_INCIDENTS_URL}/${id}`),
  getDetails: (id: number): Promise<{ data: IIncidentDetails }> =>
    requests.get(`${WEB_INCIDENTS_URL}/${id}/detail`),
  create: (payload: IIncidentCreate): Promise<IIncident> =>
    requests.post(WEB_INCIDENTS_URL, payload),
  update: (payload: Partial<IIncident>, id?: number): Promise<IIncident> =>
    requests.put(`${WEB_INCIDENTS_URL}/${id}`, payload),
  delete: (id: number): Promise<void> =>
    requests.delete(`${WEB_INCIDENTS_URL}/${id}`),
  getTypes: (): Promise<{ data: string[] }> =>
    requests.get(WEB_INCIDENT_TYPES_URL),
  getStatusTypes: (): Promise<{ data: string[] }> =>
    requests.get(WEB_INCIDENT_STATUS_TYPES_URL),
  getActivityContent: (activityId: number): string =>
    `${WEB_INCIDENT_ACTIVITIES_URL}/${activityId}/content`,
  getActivitiesByIncident: (incidentId: number) =>
    requests.get(`${WEB_INCIDENT_ACTIVITIES_URL}/incident/${incidentId}`),
  createActivity: (payload: any) =>
    requests.post(WEB_INCIDENT_ACTIVITIES_URL, payload),
  updateActivity: (id: number, payload: any) =>
    requests.put(`${WEB_INCIDENT_ACTIVITIES_URL}/${id}`, payload),
  deleteActivity: (id: number): Promise<void> =>
    requests.delete(`${WEB_INCIDENT_ACTIVITIES_URL}/${id}`),
};
